import { MeteringPoint } from "models/electricity/metering-point";
import { ElectricityAgreementForm } from "models/electricity/new-electricity-agreement";
import React, {Dispatch} from 'react';
import {Form} from 'react-bootstrap';
import NewElectricityAgreementCustomerForm from "./NewElectricityAgreementCustomerForm";
import {NewElectricityAgreementMeteringPointTable} from './NewElectricityAgreementMeteringPointTable';
import NewElectricityAgreementBillingForm from "./NewElectricityAgreementBillingForm";
import { FormContentBlock } from "components/common/FormContentBlock";

interface NewElectricityAgreementDataProps {
  isCompany: boolean,
  form: ElectricityAgreementForm,
  setForm: Dispatch<React.SetStateAction<ElectricityAgreementForm>>,
  meteringPoints: MeteringPoint[],
  setMeteringPoints: Dispatch<React.SetStateAction<MeteringPoint[]>>
}

export default function NewElectricityAgreementData({
  isCompany,
  form,
  setForm,
  meteringPoints,
  setMeteringPoints
}: NewElectricityAgreementDataProps) {
                                                      
  const meteringPointsWithExistingAgreement = meteringPoints.filter((mp) => mp.relatedAgreement);

  return (
    <div className="new-electricity-agreement__container">
      <h1>Vaadake üle andmed</h1>
      <FormContentBlock title="Klient">
        <NewElectricityAgreementCustomerForm
          form={form}
          setForm={setForm}
          isCompany={isCompany}
          isFormDisabled={false}
          showConsolidatedInvoiceCheckbox={false}
        />
        <div className="col-12 mt-3 px-0">
          <Form.Check
            id='check-sell-electricity'
            custom
            type="checkbox"
            className='checkbox-large'
            label='Soovin võrku elektrit tagasi müüa'
            onChange={() => setForm({...form, sellCheck: !form.sellCheck})}
            checked={form.sellCheck}
          />
        </div>
      </FormContentBlock>
      <FormContentBlock title="Arveldamine">
          <NewElectricityAgreementBillingForm
              form={form}
              setForm={setForm}
          />
      </FormContentBlock>
      <FormContentBlock title="Tarbimiskoht" subtitle="Vali üks või mitu mõõtepunkti.">
         <NewElectricityAgreementMeteringPointTable
            id='check-all-without-current-agreement'
            meteringPoints={meteringPoints.filter(mp => !mp.relatedAgreement)}
            setMeteringPoints={setMeteringPoints}
            form={form}
          />
          {!!meteringPointsWithExistingAgreement.length && (
            <div className="mt-4 mb-2">
              <h3>TERMINALI LEPINGUGA TARBIMISKOHAD</h3>
              <p>Sõlmitud elektrilepinguga tarbimiskoha uus elektrileping võib erineda juba sõlmitud lepingust.</p>
            </div>
          )}
          <NewElectricityAgreementMeteringPointTable
            id='check-all-with-current-agreement'
            meteringPoints={meteringPointsWithExistingAgreement}
            setMeteringPoints={setMeteringPoints}
            form={form}
          />
      </FormContentBlock>
    </div>
  )
}